import { Button } from '@components/button';
import { IconVisibilityShown } from '@components/icons/visibility-shown';
import { useScopedTranslate } from '@locale/translate';

import { showFieldsSidebar } from './fields-sidebar';
import { TableStore } from './table-store';
import { AvailableColumn, DataItemType } from './types';

export type ColumnControlProps<DataType extends DataItemType> = {
  availableColumns: Array<AvailableColumn<DataType>>;
  store: TableStore;
};

export const ColumnControl = <DataType extends DataItemType>({
  availableColumns,
  store,
}: ColumnControlProps<DataType>) => {
  const { t } = useScopedTranslate(locale);
  const { useColumnOrder, useColumnVisibility } = store;
  const { setColumnVisibility, columnVisibility } = useColumnVisibility();
  const { columnOrder, setColumnOrder } = useColumnOrder();
  return (
    <Button
      size="sm"
      variant="ghost"
      iconLeft={<IconVisibilityShown />}
      text={t('columns')}
      onClick={() => {
        showFieldsSidebar({
          availableColumns,
          columnOrder,
          columnVisibility,
          onOrderUpdate: (columnOrder) => {
            setColumnOrder(columnOrder);
          },
          onVisibilityUpdate: (visibility) => {
            setColumnVisibility(visibility);
          },
        });
      }}
    />
  );
};

const locale = {
  en: {
    columns: 'Show/Hide Fields',
  },
  is: {
    columns: 'Sýna/Fela Dálka',
  },
};
